import {useEffect, useState} from 'react';

const useClassList = (setState, autoProjectState, uploadCounter) => {
    const [activeEditId, setActiveEditId] = useState(-1);

    const activeEditClass = (classImages, classId) => {
        if (autoProjectState.activeEditId === -1 && !autoProjectState.className && !(uploadCounter > 0)) {
            setActiveEditId(classId);
            setState({classFiles: classImages, classError: '', activeEditId: classId});
        }

    };


    useEffect(() => {
        setActiveEditId(-1);
        setState({closeEditClass: false});
    }, [autoProjectState.closeEditClass]);

    return {activeEditId, activeEditClass};
};

export default useClassList;
